<template>
  <drawer
    :visible="drawerVisible"
    title="添加账号"
    size="47%"
    @closeDrawer="close"
  >
    <div class="container">
      <div class="top">
        <el-form
          ref="addmsrelationQuery"
          label-width="180px"
          :model="addmsrelationQuery"
          :rules="rules"
        >
          <el-form-item label="选择渠道号">
            <el-select
              v-model="addmsrelationQuery.slave_code"
              placeholder="请选择"
              filterable
              :clearable="false"
            >
              <el-option
                v-for="item,index in platformSelectList"
                :key="index"
                :label="item.channel_code"
                :value="item.channel_code"
              />
            </el-select>

          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker
              v-model="addmsrelationQuery.start_date"
              :clearable="false"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
              v-model="addmsrelationQuery.end_date"
              :clearable="false"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            />
          </el-form-item>
          <div class="confirm-btn">
            <span v-if="!modifyBtnFlag">
              <el-button
                type="primary"
                @click="addOfficial('addmsrelationQuery')"
              >添加</el-button>
            </span>
          </div>
        </el-form>
      </div>

      <div class="bottom">
        <el-table
          :data="accoutofficiaData.list"
          style="width: 110%"
        >
          <el-table-column
            prop="name"
            label="渠道号"
            width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.slave_channel.channel_code }}
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="渠道名称"
            width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.slave_channel.channel_name }}
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="优化师"
            width="100"
          >
            <template slot-scope="scope">
              {{ scope.row.slave_channel.optimizer }}
            </template>
          </el-table-column>
          <el-table-column
            prop="start_date"
            label="开始时间"
            align="center"
            width="100"
          />
          <el-table-column
            prop="end_date"
            label="结束时间"
            width="100"
          />
          <el-table-column
            label="操作"
            align="center"
            width="210"
          >
            <template scope="scope">
              <div style="width: 80px; display: inline-block;">
                <el-button
                  v-show="!scope.row.show"
                  type="text"
                  size="small"
                  @click="modifyData1(scope.row, scope.$index)"
                >修改</el-button>
                <el-button
                  v-show="scope.row.show"
                  type="text"
                  size="small"
                  @click="cancelModifyData1(scope.$index)"
                >取消</el-button>
                <el-button
                  v-show="scope.row.show"
                  type="text"
                  size="small"
                  @click="confirmModifyData1(scope.row)"
                >确认</el-button>
              </div>
              <div style="display: inline-block; margin-left: 25px;">
                <el-button
                  type="text"
                  size="small"
                  @click="deleteData1(scope.row)"
                >删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagination-right
          :total="accoutofficiaData.total"
          :page-sizes="[10]"
          @current-change="fetchCurrentPage"
        />
      </div>
    </div>
  </drawer>
</template>

<script>
import Drawer from '@/components/Drawer/index.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getrelationshiplist, getselectlist, channelstorage, updateChannel, deleteChannel } from '@/api/providerAccountManagement/WeChatAccountFans'
export default {
  name: 'AddAccountDrawer',
  components: {
    Drawer,
    PaginationRight
  },
  props: {
    tableData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      drawerlist: {
        channel_code: null
      },
      drawerAccountListQuery: { // 抽屉表格列表数据请求参数
        account_id: null,
        page: 1,
        page_size: 10
      },
      rules: {
        slave_id: [
          { required: true, message: '请选择公众号', trigger: 'change' }
        ],
        start_date: [
          { required: true, message: '请选择开始日期', trigger: 'change' }
        ],
        end_date: [
          { required: true, message: '请选择结束日期', trigger: 'change' }
        ]
      },

      addmsrelationQuery: {
        master_code: null, // 选定的渠道号
        slave_code: '', // 选定的次的渠道号
        start_date: '', // 开始时间
        end_date: ''// 结束时间
      },
      platformSelectList: [], // 渠道号筛选列表

      time_part: [],
      drawerVisible: false, // 抽屉开关
      accoutofficiaData: {},
      modifyBtnFlag: false // 按钮开关
    }
  },
  created() {
  },
  methods: {
    // 获取渠道号下面的子渠道号列表
    getAccountlisttwo() {
      getrelationshiplist(this.drawerlist).then(res => {
        for (let i = 0; i < res.data.list.length; i++) {
          res.data.list[i].show = false
        }
        this.accoutofficiaData = res.data
      })
    },
    // 获取渠道号筛选列表
    getPlatformSelectList() {
      this.loading = true
      getselectlist().then(res => {
        this.platformSelectList = res.data
        this.loading = false
      })
    },
    // 添加公众号
    addOfficial(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false
        }
        if (this.addmsrelationQuery.slave_code === '') {
          this.$message.error('请选择渠道号')
          return
        }
        if (this.addmsrelationQuery.start_date === '') {
          this.$message.error('请选择开始时间')
          return
        }
        if (this.addmsrelationQuery.end_date === '') {
          this.$message.error('请选择结束时间')
          return
        }

        channelstorage(this.addmsrelationQuery).then(res => {
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.clearData()
          this.getAccountlisttwo()
        })
      })
    },
    // 打开抽屉
    open(e) {
      this.drawerVisible = true
      this.drawerlist.channel_code = e.channel_code
      this.addmsrelationQuery.master_code = e.channel_code
      this.getAccountlisttwo()
      this.getPlatformSelectList()
    },
    // 关闭抽屉
    close() {
      // 关闭重置输入框数据
      this.addmsrelationQuery.master_code = null
      this.clearData()
      this.modifyBtnFlag = false
      this.drawerVisible = false
    },
    // 获取抽屉表格列表下一页的数据
    fetchCurrentPage(e) {
      this.drawerAccountListQuery.page = e
      this.getAccountlisttwo()
    },
    // 修改编辑数据
    modifyData1(e, index) {
      this.addmsrelationQuery.slave_code = e.slave_code
      this.addmsrelationQuery.start_date = e.start_date
      this.addmsrelationQuery.end_date = e.end_date
      this.modifyBtnFlag = true
      for (let i = 0; i < this.accoutofficiaData.list.length; i++) {
        this.accoutofficiaData.list[i].show = false
      }
      this.accoutofficiaData.list[index].show = true
    },
    // 取消修改编辑数据
    cancelModifyData1(index) {
      this.clearData()
      this.accoutofficiaData.list[index].show = false
      this.modifyBtnFlag = false
    },
    // 确认修改编辑数据
    confirmModifyData1(e) {
      updateChannel(e.id, {
        slave_code: this.addmsrelationQuery.slave_code,
        start_date: this.addmsrelationQuery.start_date,
        end_date: this.addmsrelationQuery.end_date
      }).then(res => {
        this.clearData()
        this.getAccountlisttwo()
        this.modifyBtnFlag = false
      })
    },
    // 删除当前点击数据
    deleteData1(e) {
      deleteChannel(e.id).then(res => {
        // this.addmsrelationQuery.slave_id = null
        // this.addmsrelationQuery.start_date = ''
        // this.addmsrelationQuery.end_date = ''
        this.getAccountlisttwo()
        // this.modifyBtnFlag = false
      })
    },
    // 清空数据
    clearData() {
      this.addmsrelationQuery.slave_code = ''
      this.addmsrelationQuery.start_date = ''
      this.addmsrelationQuery.end_date = ''
    }

  }
}
</script>

<style lang="less" scoped>
.container {
  margin: 0 auto;
  padding: 0 5%;
  .status {
    display: flex;
    div {
      width: 180px;
    }
  }
}
.top {
  width: 500px;
  margin: 0 auto;
  overflow: auto;
  .confirm-btn {
    margin-left: 20px;
    float: right;
  }
  .status-box {
    overflow: auto;
    max-height: 120px;
  }
}
.bottom {
  width: 850px;
  // height: 500px;
  margin: 50px auto;
  padding-right: 16px;
}
.column-display {
  display: flex;
  align-content: center;
  justify-content: center;
  margin-top: 20px;
}
.input-border {
  width: 60px;
  border: 1px solid #ccc;
  height: 30px;
  border-radius: 5px;
}
/deep/ .row-display {
  margin-left: 20px;
  font-size: 15px;
}
</style>
